import { Component } from '@angular/core';
import {AlertController, NavController} from 'ionic-angular';
import {AngularFire, FirebaseListObservable} from 'angularfire2';

import {ThemeService, AuthService} from '../../../providers/index';
@Component({
  selector: 'page-bill-summary',
  templateUrl: 'bill-summary.html'
})
export class BillSummaryPage {

  billList: FirebaseListObservable<any>;
  project: string;

  constructor(public navCtrl: NavController, public af: AngularFire,
              public alertCtrl: AlertController, private _theme: ThemeService,private _auth: AuthService) {
    this.billList = af.database.list('/bills');

    console.log('Theme: ' + this._theme.getNameOfTheme());

    this.project = this._theme.getNameOfTheme();

  }

  promptPayment(billId: string) {
    let alert = this.alertCtrl.create({
      message: "Mark as paid?",
      buttons: [
        {
          text: 'Cancel',
        },
        {
          text: 'Mark as Paid',
          handler: data => {
            this.billList.update(billId, { paid: true });
          }
        }
      ]
    });
    alert.present();
  }


  ionViewDidLoad() {
    console.log('ionViewDidLoad BillSummaryPage');
  }
  // Only go here if we need to
  ionViewCanEnter(): boolean {
    if(this._auth.authenticated){
      console.log('Authenticated so you can see this page: ');
      return true;
    } else {
      console.log('Not Authenticated so you cannot see this page: '); //TODO: Add reference to page
      return false;
    }
  }

}


// WEBPACK FOOTER //
// ./src/pages/bill/bill-summary/bill-summary.ts